// extracted by mini-css-extract-plugin
export var lg = "_ed-7";
export var md = "_ed-6";
export var placeholderContainer = "_ed-1";
export var placeholderIcon = "_ed-2";
export var productImage = "_ed-0";
export var sm = "_ed-5";
export var xl = "_ed-8";
export var xs = "_ed-4";
export var xxs = "_ed-3";